import type { FeedMediaItem } from '~/components/PropertyReelsFeed/types';

/** Mantém a primeira ocorrência de cada imóvel sem alterar a ordem. */
export function uniqueFeedItemsByCommercialId<T extends FeedMediaItem>(
	items: T[]
): T[] {
	const seenCommercialIds = new Set<string>();

	return items.filter(item => {
		const commercialId = item.property.commercialId;
		if (seenCommercialIds.has(commercialId)) return false;

		seenCommercialIds.add(commercialId);
		return true;
	});
}
